/**
 * ESP State Finder — Ajax-driven provider card swap.
 *
 * Fetches a rendered Twig partial from /education/esp-provider?state=XX
 * and replaces the provider card section without a full page reload.
 * Dims the card while loading, waits for the logo to load before fading back in.
 */
export default function EspFinder(initialState = '') {
  const FADE_MS = 220;

  return {
    state: initialState,
    loading: false,

    async navigate() {
      if (!this.state) return;

      this.loading = true;
      await this.sleep(FADE_MS);

      try {
        const url = `/education/esp-provider?state=${encodeURIComponent(this.state)}`;
        const response = await fetch(url);

        if (!response.ok) return;

        const html = await response.text();
        this.$refs.providerCard.innerHTML = html;

        await this.waitForLogo();

        const params = new URLSearchParams();
        params.set('state', this.state);
        history.pushState({ state: this.state }, '', `${window.location.pathname}?${params}`);
      } finally {
        this.loading = false;
      }
    },

    waitForLogo() {
      const img = this.$refs.providerCard.querySelector('img');
      if (!img || img.complete) return Promise.resolve();

      return new Promise((resolve) => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
        setTimeout(resolve, 3000);
      });
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    init() {
      window.addEventListener('popstate', (event) => {
        const params = new URLSearchParams(window.location.search);
        const newState = params.get('state') || '';

        if (newState !== this.state) {
          this.state = newState;
          if (this.state) {
            this.navigate();
          }
        }
      });
    },
  };
}
